import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithCustomToken, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { KJUR } from 'jsrsasign';
import { getFunctions, httpsCallable, httpsCallableFromURL, connectFunctionsEmulator } from 'firebase/functions';

let functions = null;
let app = null;

const clientAud = process.env.REACT_APP_GOOGLE_CLIENT_ID;

class firebaseHelper {
    constructor(config) {
        if (!firebaseHelper.instance) {
            firebaseHelper.instance = this;
            firebaseHelper.instance._db = null;
            firebaseHelper.instance._token = null;
            firebaseHelper.instance._idToken = null;
            firebaseHelper.instance._user = null;
            firebaseHelper.instance._init = false;
        }

        if (config) {
            firebaseHelper.instance._serviceAccount = config.FirebaseServiceAccount
                ? JSON.parse(config.FirebaseServiceAccount)
                : '';
            firebaseHelper.instance._firebaseConfig = config.FirebaseConfig ? JSON.parse(config.FirebaseConfig) : '';
            firebaseHelper.instance._webAPIKey = config.FirebaseWebAPIKey;
            firebaseHelper.instance._dbName = config.DatabaseName ? config.DatabaseName : 'oem_test';
            firebaseHelper.instance._tenant = config.TenantName ? config.TenantName : 'oem_test';
            if (config.FirebaseServiceAccount && config.FirebaseConfig && config.FirebaseWebAPIKey)
                firebaseHelper.instance._firebaseConfigStatus = true;
            else firebaseHelper.instance._firebaseConfigStatus = false;
        }

        return firebaseHelper.instance;
    }

    getStatus() {
        return this._firebaseConfigStatus;
    }
    initialize() {
        if (!this.getStatus) return null;

        if (this._init) return app;

        this._init = true;
        app = initializeApp(this._firebaseConfig);
        let auth = getAuth();
        let jwtToken = this.generateJwtToken();

        signInWithCustomToken(auth, jwtToken)
            .then((userCredential) => {
                auth = userCredential.user.auth;
                this._user = userCredential.user;
                // const firebaseUserIdToken = userCredential.user.getIdToken(true).then((token) => {
                //     console.log(token);
                // });
                // console.log(userCredential);
                // this.WriteDocument(db);
                // this.getDocument(db);
            })
            .catch((error) => {
                console.log(error);
                // const errorCode = error.code;
                // const errorMessage = error.message;
                // ...
            });
        const db = getFirestore(app);
        this._db = db;

        onAuthStateChanged(auth, (state) => {
            console.log('state changed', state);
        });
        //todo observe onOuthStateChange event

        return app;
    }

    // async googleAuth() {
    //     let keys = this._serviceAccount;
    //     const client = new JWT({
    //         email: keys.client_email,
    //         key: keys.private_key,
    //         scopes: ['https://www.googleapis.com/auth/cloud-platform']
    //     });
    //     const url = `https://dns.googleapis.com/dns/v1/projects/${keys.project_id}`;
    //     const res = await client.request({ url });
    //     console.log(res.data);
    // }

    getOauth2AccessToken() {
        return this._oauth2AccessToken;
    }

    setOauth2AccessToken(token) {
        this._oauth2AccessToken = token;
    }

    getOauth2IdToken() {
        return this._oauth2IdToken;
    }

    setOauth2IdToken(token) {
        this._oauth2IdToken = token;
    }

    getIdentityToken() {
        return this._identityToken;
    }

    setIdentityToken(token) {
        this._identityToken = token;
    }

    getRefreshToken() {
        return this._refreshToken;
    }

    setRefreshToken(token) {
        this._refreshToken = token;
    }

    getServiceAccountEmail() {
        return this._serviceAccount.client_email;
    }

    getServiceClientId() {
        return clientAud;
    }

    getDb() {
        return this._db;
    }

    getTenant() {
        return this._tenant;
    }

    getdbName() {
        return this._dbName;
    }

    getWebApiKey() {
        return this._webApiKey;
    }

    checkToken() {
        let uid = 'oem-labs-firebase-poc';

        let aa = getAuth()
            .revokeRefreshTokens(uid)
            .then(() => {
                return getAuth().getUser(uid);
            })
            .then((userRecord) => {
                return new Date(userRecord.tokensValidAfterTime).getTime() / 1000;
            })
            .then((timestamp) => {
                console.log(`Tokens revoked at: ${timestamp}`);
            });

        console.log(aa);
    }

    // refreshToken() {
    //     // Verify the ID token while checking if the token is revoked by passing
    //     // checkRevoked true.
    //     let checkRevoked = true;
    //     getAuth()
    //         .verifyIdToken(idToken, checkRevoked)
    //         .then((payload) => {
    //             console.log(payload);

    //             // Token is valid.
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             if (error.code == 'auth/id-token-revoked') {
    //                 // Token has been revoked. Inform the user to reauthenticate or signOut() the user.
    //             } else {
    //                 // Token is invalid.
    //             }
    //         });
    // }

    // https://cloud.google.com/functions/docs/securing/authenticating
    // Generate an ID token and sign it with the private key.
    generateJwtTokenForOauth2() {
        let privateKeyId = this._serviceAccount.private_key_id;
        let sPKCS8PEM = this._serviceAccount.private_key;
        let sub = this._serviceAccount.client_email;

        var uid = this._serviceAccount.project_id;
        if (uid == '') {
            console.log('Blank uid');
            return;
        }
        // Header
        var oHeader = { alg: 'RS256', kid: privateKeyId, typ: 'JWT' };

        var tNow = KJUR.jws.IntDate.get('now');
        var tEnd = KJUR.jws.IntDate.get('now + 1hour');

        // Payload
        var oPayload = {
            iss: sub,
            sub: sub,
            scope: 'https://www.googleapis.com/auth/cloud-platform',
            iat: tNow,
            exp: tEnd,
            user_id: uid
        };

        oPayload.aud = 'https://www.googleapis.com/oauth2/v4/token';

        var sHeader = JSON.stringify(oHeader);
        var sPayload = JSON.stringify(oPayload);

        var sJWT = KJUR.jws.JWS.sign('RS256', sHeader, sPayload, sPKCS8PEM);

        console.log(sJWT);
        return sJWT;
    }

    // Generate an ID token and sign it with the private key.
    generateJwtToken() {
        let privateKeyId = this._serviceAccount.private_key_id;
        let sPKCS8PEM = this._serviceAccount.private_key;
        let sub = this._serviceAccount.client_email;

        var uid = this._serviceAccount.project_id;
        if (uid == '') {
            console.log('Blank uid');
            return;
        }
        // Header
        var oHeader = { alg: 'RS256', kid: privateKeyId, typ: 'JWT' };

        var tNow = KJUR.jws.IntDate.get('now');
        var tEnd = KJUR.jws.IntDate.get('now + 1hour');

        // Payload
        var oPayload = {
            iss: sub,
            sub: sub,
            scope: 'https://www.googleapis.com/auth/identitytoolkit',
            iat: tNow,
            exp: tEnd,
            user_id: uid
        };

        oPayload.aud = 'https://identitytoolkit.googleapis.com/google.identity.identitytoolkit.v1.IdentityToolkit';

        var sHeader = JSON.stringify(oHeader);
        var sPayload = JSON.stringify(oPayload);

        var sJWT = KJUR.jws.JWS.sign('RS256', sHeader, sPayload, sPKCS8PEM);
        return sJWT;
    }

    //Working with local Emulator
    //
    helloWorldLocal(name) {
        functions = getFunctions(app);
        connectFunctionsEmulator(functions, 'localhost', 5001);

        var sayHello = httpsCallable(functions, 'getWorkspaceDetail');

        // call the function and pass data
        sayHello(name)
            .then((result) => {
                console.log(result);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async helloWorldRemote(name) {
        functions = getFunctions(app);

        const context = await functions.contextProvider.getContext();

        context.authToken = this._idToken;
        var sayHello = httpsCallable(functions, 'helloWorld3');

        // console.log(this._idToken);

        // call the function and pass data
        sayHello(name)
            .then((result) => {
                console.log(result.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    testFunction() {
        const auth = getAuth();
        functions = getFunctions(app);
        signInWithEmailAndPassword(auth, "tuncay.yakar@oem'.com", '1').then(() => {
            const sayHello = httpsCallableFromURL(functions, process.env.REACT_APP_HELLO_FUNCTION_URL);
            //var sayHello = httpsCallable(functions, 'helloWorld');

            // call the function and pass data
            sayHello('name')
                .then((result) => {
                    console.log(result.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }
}

export default firebaseHelper;
